document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swiper").forEach((swiperElement) => {
    const slidesPerView = parseInt(swiperElement.getAttribute("data-slidesperview"), 10) || 1;
    const mobileSlides = parseInt(swiperElement.getAttribute("data-mobileSlides"), 10) || 1;
    const spaceBetween = parseInt(swiperElement.getAttribute("data-spacebetween"), 10) || 0;
    const autoplay = swiperElement.getAttribute("data-autoplay") === "true";
    const autoplayDelay = parseInt(swiperElement.getAttribute("data-autoplay-delay"), 10) || 3000;
    const loop = swiperElement.getAttribute("data-loop") === "true";
    const speed = parseInt(swiperElement.getAttribute("data-speed"), 10) || 300;
    const nextEl = swiperElement.parentElement.querySelector(".swiper-next");
    const prevEl = swiperElement.parentElement.querySelector(".swiper-prev");
    const paginationEl = swiperElement.parentElement.querySelector(".swiper-pagination");
    
    new Swiper(swiperElement, {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: loop,
      speed: speed,
      autoplay: autoplay ? { delay: autoplayDelay } : false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      scrollbar: {
        el: '.cus-swiper-scrollbar',
        hide: true,
        draggable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        0: { slidesPerView: mobileSlides, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: spaceBetween },
        1200: { slidesPerView: slidesPerView, spaceBetween: spaceBetween }
      }
    });
  });
});





document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.logo-swiper-container', {
        loop: false,
        paginationClickable: true,
        spaceBetween: 20,
        scrollbar: {
          el: '.cus-logo-scrollbar',
          hide: true,
          draggable: true,
        },
        breakpoints: {
            1200: {
                slidesPerView: 6,
                spaceBetween: 30
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            500: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            0: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });
});